export const TRANSLATION_GROUP_PREFIX = 'Context window: Indicator:';

export const MAIN_CLASS_NAME = 'context-window-indicator';
export const PERCENT_CLASS_NAME = `${MAIN_CLASS_NAME}__percent`;

export const ROW_OK_CLASS_NAME = `${MAIN_CLASS_NAME}_ok`;
export const ROW_WARNING_CLASS_NAME = `${MAIN_CLASS_NAME}_warning`;
export const ROW_DANGER_CLASS_NAME = `${MAIN_CLASS_NAME}_danger`;

export const RING_SIZE = 12;
export const RING_STROKE_WIDTH = 8;

export const WARNING_THRESHOLD_PERCENT = 70;
export const DANGER_THRESHOLD_PERCENT = 90;
